import Vue from 'vue';
import './main-global.ts';
import App from './App.vue';
import router from './router';
import '@root/static/css/index.less';
import sso from './utils/sso';

import Bfui from 'bfui';
import 'bfui/lib/theme-default/index.css';

Vue.use(Bfui);

sso.login().then(()=>{
    window['_app'] = new Vue({
        el: '#app',
        router,
        // template: '<router-view></router-view>',
        // template: '<App/>', // 这种方式用了路由就不显示了
        render: h => h(App), // 这种方式用了路由也会显示
        // components: { App }
    });
});
Vue.config.productionTip = false;



// cat 错误测试
if ($qsObj.error === 'true') {
    setTimeout(() => {
        throw new Error('err_123');
    }, 5000);
}
